(function(){
  var root=document.getElementById('cfmd');if(!root)return;
  var data;try{data=JSON.parse(document.getElementById('cfm-data').textContent)}catch(e){return}
  data=data.filter(function(c){return c.opts.length>0});
  var c1=document.getElementById('cfm-cta1'),c2=document.getElementById('cfm-cta2');
  var base2=c2?c2.getAttribute('href'):'';
  var priceEl=document.getElementById('cfm-precio');
  var current=null,busy=false,label=c1?c1.textContent:'';

  /* Rating under the title: 4.8 → four solid stars plus one 80%-filled. */
  var CFG=window.CFM_RATING||{score:'4,8',filled:4,partial:80,label:'de 5 en atenci\u00f3n y entrega',href:'#cfm-resenas'};
  var GID='cfmStarPart';
  function starSolid(c){return '<svg width="15" height="15" viewBox="0 0 24 24" fill="'+c+'"><path d="M12 2.6l2.9 6.1 6.6.9-4.8 4.6 1.2 6.6L12 17.6 6.1 20.8l1.2-6.6L2.5 9.6l6.6-.9z"/></svg>'}
  function starPartial(pct){
    return '<svg width="15" height="15" viewBox="0 0 24 24"><defs><linearGradient id="'+GID+'"><stop offset="'+pct+'%" stop-color="#151515"/><stop offset="'+pct+'%" stop-color="#cfcfcf"/></linearGradient></defs><path fill="url(#'+GID+')" d="M12 2.6l2.9 6.1 6.6.9-4.8 4.6 1.2 6.6L12 17.6 6.1 20.8l1.2-6.6L2.5 9.6l6.6-.9z"/></svg>'
  }
  function mountRating(){
    if(document.getElementById('cfm-rating'))return;
    var title=document.getElementById('cfm-nombre');if(!title)return;
    var a=document.createElement('a');
    a.id='cfm-rating';a.className='cfm-rating';a.href=CFG.href;
    var s='';
    for(var i=1;i<=5;i++){
      if(i<=CFG.filled)s+=starSolid('#151515');
      else if(i===CFG.filled+1&&CFG.partial)s+=starPartial(CFG.partial);
      else s+=starSolid('#cfcfcf');
    }
    a.innerHTML='<span class="st">'+s+'</span><span class="sc">'+CFG.score+'</span><span class="lb">'+CFG.label+'</span>';
    title.insertAdjacentElement('afterend',a);
  }

  function activeIndex(){
    var ci=0;
    root.querySelectorAll('#cfm-lineas .lin').forEach(function(lin,i){
      var n=lin.querySelector('.lname');
      if(n&&parseInt(getComputedStyle(n).fontWeight,10)>=600)ci=i;
    });
    var vi=0;
    root.querySelectorAll('#cfm-opciones .obtn').forEach(function(b,i){if(b.classList.contains('on'))vi=i});
    return [ci,vi];
  }
  function sync(){
    mountRating();
    var ix=activeIndex(),line=data[ix[0]];if(!line)return;
    current=line.opts[ix[1]]||null;if(!current)return;
    if(c2)c2.setAttribute('href',current.url||base2);
    if(priceEl&&current.precio){
      var html='<span class="now">'+current.precio+'</span>';
      if(current.antes)html+='<span class="was">'+current.antes+'</span>';
      if(current.off)html+='<span class="off">-'+current.off+'%</span>';
      priceEl.innerHTML=html;
      priceEl.classList.toggle('sale',!!current.antes);
    }
  }
  if(c1){
    c1.setAttribute('href','#');
    c1.addEventListener('click',function(ev){
      if(!current||!current.vid)return;
      ev.preventDefault();
      if(busy)return;busy=true;c1.textContent='Agregando\u2026';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:current.vid,quantity:1})})
        .then(function(r){if(!r.ok)throw 0;window.location.href='/cart';})
        .catch(function(){busy=false;c1.textContent=label;if(current.url)window.location.href=current.url;});
    });
  }
  root.addEventListener('click',function(){setTimeout(sync,0)});
  var t=0,iv=setInterval(function(){if(root.querySelector('#cfm-opciones .obtn')||++t>40){clearInterval(iv);sync();}},50);

  var rev=document.querySelector('.cfr');
  if(rev&&!rev.id)rev.id='cfm-resenas';
})();
